import ElementUI from 'element-ui'; /*node_modules引入了element-ui 这里就可以直接引用了*/
import axios from 'axios' //引入axios
// import globelVar from '@/globelVar.js'
import store from '@/store';

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.timeout = 30000

export default{
    m9001json(){
        const m9001Input = {
            opter_no:"FY6666",
            mac:"94:C6:91:94:26:EE",
            ip:"10.10.120.40"
        }
        this.request_yb('m9001json', m9001Input).then(res => {
            if (res.infcode == "0") {
              console.log("sign_no",res);
              store.dispatch('changeSignNo', res.sign_no);
            } else {
                ElementUI.Message({
                    message: "医保签到失败："+res.err_msg,
                    type: 'error',
                    offset:300
                })
            }
        })
        
    },

    async m1101json(input){
      let result ="-1"
      await this.request_yb('m1101json', input).then(res => {
            if (res.infcode == "0") {
                store.dispatch('changeM1101Output', res);
                store.dispatch('changeM1101Input', this.m1101);
                
                store.dispatch('changeYbflag', "1");

                this.m5301json()
                this.m5391json()
                result = "1"
            } else {
                ElementUI.Message({
                    message: "医保信息查询失败："+res.err_msg,
                    type: 'error',
                    offset:300
                })

                result = "-1"
            }
        })

        return  result
    },

    m5301json(){
       const m5301Input = {
            sign_no:store.state.ybStore.sign_no,
            insuplc_admdvs:store.state.ybStore.insuplc_admdvs,
            input:{
                data:{	
                    psn_no:store.state.ybStore.m1101Output.output.baseinfo.psn_no
                }
            }
        }

        this.request_yb('m5301json', m5301Input).then(res => {
            if (res.infcode == "0") {
                store.dispatch('changeM5301Output', res);
                store.dispatch('changeM5301Input', m5301Input);
            }
        })
    },

    m5391json(){
        const m5391Input = {
            sign_no:store.state.ybStore.sign_no,
            insuplc_admdvs:store.state.ybStore.insuplc_admdvs,
            input:{
                data:{	
                    psn_no:store.state.ybStore.m1101Output.output.baseinfo.psn_no,
                    begndate:"",
                    enddate:""
                }
            }
        }

        this.request_yb('m5391json', m5391Input).then(res => {
            if (res.infcode == "0") {
                store.dispatch('changeM5391Output', res);
                store.dispatch('changeM5391Input', m5391Input);
            }
        })

    },

    async m2201Json(m2201input){
      let result = "-1"

			m2201input.sign_no = store.state.ybStore.sign_no
      m2201input.insuplc_admdvs = store.state.ybStore.insuplc_admdvs

      await this.request_yb('m2201json', m2201input).then(res => {

        console.log("m2201Json",res,result)
        if (res.infcode == "0") {
          store.dispatch('changeM2201Output', res);
          store.dispatch('changeM2201Input', m2201input);
          result ="1"
        }

        
      })
      return result
    },

    async m2202Json(){
      let result = "-1"

      let m2202input={
        insuplc_admdvs:store.state.ybStore.insuplc_admdvs,//参保地医保区划
        sign_no:store.state.ybStore.sign_no,//交易签到流水号
        input:{
          data:{	
            "psn_no": store.state.ybStore.m1101Output.output.baseinfo.psn_no,
            "mdtrt_id": store.state.ybStore.m2201Output.output.data.mdtrt_id,
            "ipt_otp_no": store.state.ybStore.m2201Output.output.data.ipt_otp_no,
            "expContent": ""
          }
        }//交易输入
      }

      await this.request_yb('m2202json', m2202input).then(res => {

        console.log("m2202Json",res,result)
        if (res.infcode == "0") {
          // store.dispatch('changeM2202Output', res);
					// store.dispatch('changeM2202Input', m2202input);
          store.dispatch('changeM2203Output', {});
					store.dispatch('changeM2203Input', {});
          store.dispatch('changeM2201Output', {});
					store.dispatch('changeM2201Input', {});
          result ="1"
        }
      })
      return result
    },

    async m2203Json(m2203input){
      let result = "-1"

      m2203input.sign_no = store.state.ybStore.sign_no
      m2203input.insuplc_admdvs = store.state.ybStore.insuplc_admdvs

      console.log("m2203",JSON.stringify(m2203input))

      m2203input.input.mdtrtinfo.mdtrt_id = store.state.ybStore.m2201Output.output.data.mdtrt_id

      await this.request_yb('m2203json', m2203input).then(res => {

        console.log("m2203Json",res,result)
        if (res.infcode == "0") {
          store.dispatch('changeM2203Output', res);
					store.dispatch('changeM2203Input', m2203input);
          result ="1"
        } 
      })
      return result
    },

    async m2204Json(m2204input){
      let result = "-1"

			m2204input.sign_no = store.state.ybStore.sign_no
      m2204input.insuplc_admdvs = store.state.ybStore.insuplc_admdvs

      await this.request_yb('m2204json', m2204input).then(res => {

        console.log("m2204Json",res,result)
        if (res.infcode == "0") {
          store.dispatch('changeM2204Output', res);
          store.dispatch('changeM2204Input', m2204input);
          result ="1"
        }  
      })
      return result
    },

    async m2205Json(){
      let result = "-1"

      let m2205input={
        insuplc_admdvs:store.state.ybStore.insuplc_admdvs,//参保地医保区划
        sign_no:store.state.ybStore.sign_no,//交易签到流水号
        input:{
          data:{	
            "psn_no": store.state.ybStore.m1101Output.output.baseinfo.psn_no,
            "mdtrt_id": store.state.ybStore.m2201Output.output.data.mdtrt_id,
            "chrg_bchno": "0000",
            "expContent": ""
          }
        }//交易输入
      }

      await this.request_yb('m2205json', m2205input).then(res => {

        console.log("m2205Json",res,result)
        if (res.infcode == "0") {
          // store.dispatch('changeM2205Output', res);
					// store.dispatch('changeM2205Input', m2205input);
          store.dispatch('changeM2204Output', {});
					store.dispatch('changeM2204Input', {});
          store.dispatch('changeYbyjsflag', "");
          result ="1"
        }
      })
      return result
    },

    async m2206Json(m2206input){
      let result = "-1"

			m2206input.sign_no = store.state.ybStore.sign_no
      m2206input.insuplc_admdvs = store.state.ybStore.insuplc_admdvs

      await this.request_yb('m2206json', m2206input).then(res => {

        console.log("m2206Json",res,result)
        if (res.infcode == "0") {
          store.dispatch('changeM2206Output', res);
          store.dispatch('changeM2206Input', m2206input);
          result ="1"
        }  
      })
      return result
    },

    async m2207Json(m2207input){
      let result = "-1"

			m2207input.sign_no = store.state.ybStore.sign_no
      m2207input.insuplc_admdvs = store.state.ybStore.insuplc_admdvs

      await this.request_yb('m2207json', m2207input).then(res => {

        console.log("m2207Json",res,result)
        if (res.infcode == "0") {
          store.dispatch('changeM2207Output', res);
          store.dispatch('changeM2207Input', m2207input);
          store.dispatch('changeYbjsflag', "1");
          result ="1"
        }  
      })
      return result
    },

    async m2208Json(){
      let result = "-1"

      let m2208input ={
        sign_no: store.state.ybStore.sign_no,
	      insuplc_admdvs: store.state.ybStore.insuplc_admdvs,
        input: {
          data: {
            setl_id: store.state.ybStore.m2207Output.output.setlinfo.setl_id,
            mdtrt_id: store.state.ybStore.m2207Output.output.setlinfo.mdtrt_id,
            psn_no: store.state.ybStore.m2207Output.output.setlinfo.psn_no,
            expContent: ""
          }
	      }
      }

      await this.request_yb('m2208json', m2208input).then(res => {

        console.log("m2208Json",res,result)
        if (res.infcode == "0") {
          // store.dispatch('changeM2208Output', res);
          // store.dispatch('changeM2208Input', m2208input);
          store.dispatch('changeM2207Output', {});
          store.dispatch('changeM2207Input', {});
          store.dispatch('changeYbjsflag', "");
          result ="1"
        }  
      })
      return result
    },

    // async yb_yjs(input){
    //   let result = "-1"
    //   let bakresult ="-1"
      
    //   //2201
    //   let m2201input = input.m2201
    //   result = await this.m2201Json(m2201input);

    //   if(result != 1){
    //     console.log("m2201output",result)
    //     return result
    //   }

    //   //2203
    //   let m2203input = input.m2203
    //   result = await this.m2203Json(m2203input)

    //   if(result != 1){
    //     //2203报错，调用2202取消挂号
    //     bakresult = await this.m2202Json()
    //     console.log("m2202output",bakresult)
    //     console.log("m2203output",result)
    //     return result
    //   }

    //   let m2204input = input.m2204

    //   console.log("m2204input",JSON.stringify(m2204input))  
      
    //   //循环更新就诊id
    //   for (let i = 0; i < m2204input.input.feedetail.length; i++) {
    //     m2204input.input.feedetail[i].mdtrt_id = store.state.ybStore.m2201Output.output.data.mdtrt_id
    //   }

    //   result = await this.m2204Json(m2204input)
    //   if(result != 1){
    //     //2204报错，调用2202取消挂号
    //     bakresult = await this.m2202Json()
    //     console.log("m2202output",bakresult)
    //     console.log("m2204output",result)
    //     return result
    //   }

    //   //2206 
    //   let m2206input = input.m2206
    //   m2206input.input.data.mdtrt_id= store.state.ybStore.m2201Output.output.data.mdtrt_id

    //   result = await this.m2206Json(m2206input)
    //   if(result != 1){
    //     //2206报错，调用2205取消费用明细上次，2202取消挂号
    //     bakresult = await this.m2205Json()
    //     console.log("m2205output",bakresult)
    //     if(bakresult == "1"){
    //       bakresult = await this.m2202Json()
    //     }
        
    //     console.log("m2202output",bakresult)
    //     console.log("m2204output",result)
    //     return result
    //   }
      
    //   return result
    // },

    // async yb_js(){
    //   let result = "-1"
    //   let bakresult = "-1"
    //   //2207  
    //   let m2207input = store.state.ybStore.m2206Input
    //   m2207input.input.data.invono  =""
    //   m2207input.input.data.fulamt_ownpay_amt  =""
    //   m2207input.input.data.overlmt_selfpay  =""
    //   m2207input.input.data.preselfpay_amt  =""
    //   m2207input.input.data.inscp_scp_amt  =""

    //   result = await this.m2207Json(m2207input)
    //   if(result != 1){
    //     //2206报错，调用2205取消费用明细上次，2202取消挂号
    //     bakresult = await this.m2205Json()
    //     console.log("m2205output",bakresult)
    //     if(bakresult == "1"){
    //       bakresult = await this.m2202Json()
    //     }
        
    //     console.log("m2202output",bakresult)
    //     console.log("m2204output",result)
    //     return result
    //   }

    //   return result
    // },

    // async yb_js_tf(){
    //   let result = "-1"

    //   result =  await this.m2208Json()
    //   if(result == 1){
    //     //2206报错，调用2205取消费用明细上次，2202取消挂号
    //     result = await this.m2205Json()
    //     if(result == "1"){
    //       result = await this.m2202Json()
    //     }
    //   }

    //   return result
    // },

    // async yb_yjs_tf(){
    //   let result = "-1"
    //   let m2204Output = store.state.ybStore.m2204Output
    //   if (JSON.stringify(m2204Output) != '{}' && m2204Output != undefined) {
    //     result = await this.m2205Json()
    //   }

    //   let m2201Output = store.state.ybStore.m2201Output
    //   if (JSON.stringify(m2201Output) != '{}' &&  m2201Output != undefined) {
    //     result = await this.m2202Json()
    //   }

    //   return result
    // },

    // request_yb1(code,input){
    //     console.log(input);
        
    //     let para = {
    //       infno:"",//交易编号
    //               msgid:"",//发送方报文 ID 
    //               mdtrtarea_admvs:"360702",//就医地医保区划
    //               insuplc_admdvs:"",//参保地医保区划
    //               recer_sys_code:"360702",//接收方系统代码
    //               dev_no:"",//设备编号
    //               dev_safe_info:"",//设备安全信息
    //               cainfo:"",//数字签名信息
    //               signtype:"SM3",//签名类型
    //               infver:"V1.0",//接口版本号
    //               opter_type:"1",//经办人类别
    //               opter:"00002",//经办人
    //               opter_name:"00002",//经办人姓名
    //               inf_time:"",//交易时间
    //               fixmedins_code:"H36070200017",//定点医药机构编号
    //               fixmedins_name:"赣南医学院第一附属医院",//定点医药机构名称
    //               sign_no:"",//交易签到流水号
    //       input:{
  
    //       }
    //     }
  
    //     if (code=="m9001json") {
    //       para.infno = "9001"
    //     } else if (code=="m1101json") {
    //       para.infno = "1101"
    //     } else if (code=="m5301json") {
    //       para.infno = "5301"
    //     } else if (code=="m5391json") {
    //       para.infno = "5391"
    //     } else if (code=="m2201json") {
    //       para.infno = "2201"
    //     } else if (code=="m2202json") {
    //       para.infno = "2202"
    //     } else if (code=="m2203json") {
    //       para.infno = "2203"
    //     } else if (code=="m2204json") {
    //       para.infno = "2204"
    //     } else if (code=="m2205json") {
    //       para.infno = "2205"
    //     } else if (code=="m2206json") {
    //       para.infno = "2206"
    //     } else if (code=="m2207json") {
    //       para.infno = "2207"
    //     } else if (code=="m2208json") {
    //       para.infno = "2208"
    //     }
  
    //     if (code=="m9001json" ) {
    //       para.insuplc_admdvs = "360702"    
    //       para.input= input 
    //     } else if (code=="m1101json" ) {
    //       para.insuplc_admdvs = store.state.ybStore.insuplc_admdvs
    //       para.sign_no = input.sign_no
    //       para.input= input.input
    //     } else{
    //       para.insuplc_admdvs = input.insuplc_admdvs
    //       para.sign_no = input.sign_no
    //       para.input= input.input
    //     }
  
    //     const nowdate = globelVar.tools.getNowDate();
    //           para.inf_time=nowdate;
    //           let reg=new RegExp('-','g')
    //           let reg1=new RegExp(':','g')
    //           para.msgid = para.fixmedins_code + nowdate.replace(reg,"").replace(" ","").replace(reg1,"") + (Math.floor(Math.random() * 9999 ) + 1)
        
    //       return axios({
    //         method:'post',
    //         url: "/yb",
    //         data: {
    //           "qqflag":"1",
    //           "infcode":code,
    //           "input":para
    //         }
    //       }).then(res => {
    //         console.log(res)
    //         return res.data;     
    //       }).catch(err => {
    //         console.error(err); 
    //         return err.data        
    //       });
        
    //   },


      async yb1001(yb1001_input){
        // console.log("yb1001","222")
        let result ="-1"
        await this.request_yb('yb1001', yb1001_input).then(res => {
              if (res.infcode == "0") {
                  // console.log(res)
                  
                  store.dispatch('changeM1101Input', res.output.m1101rc);
                  store.dispatch('changeM1101Output', res.output.m1101);
                  store.dispatch('changeM5301Output', res.output.m5301);

                  store.dispatch('changeYb1001Input', yb1001_input);
                  store.dispatch('changeYb1001Output', res);
                  
                  store.dispatch('changeYbflag', "1");
                  result = "1"
              } else {
                  ElementUI.Message({
                      message: "医保信息查询失败："+res.err_msg,
                      type: 'error',
                      offset:300
                  })

                  result = "-1"
              }
        })

        return  result
      },

      async yb2001(input){
        let result ="-1"
        await this.request_yb('yb2001', input).then(res => {
          if (res.infcode == "0") {
              console.log(res)
              
              store.dispatch('changeM2201Output', res.output.m2201);
              store.dispatch('changeM2204Output', res.output.m2204);
              store.dispatch('changeM2207Output', res.output.m2207);
              store.dispatch('changeM2207Input', res.output.m2207rc);

              store.dispatch('changeYb2001Input', input);
              store.dispatch('changeYb2001Output', res);
              store.dispatch('changeYbjsflag','1')
              result = "1"
          } else {
              ElementUI.Message({
                  message: "医保结算失败："+res.err_msg,
                  type: 'error',
                  offset:300
              })

              result = "-1"
          }
        })

        return  result
      },

      async yb2005(v_omsgid,v_oinfno){
        let result = "-1"
        
        let input = {
          "insuplc_admdvs":store.state.ybStore.insuplc_admdvs,	//参保地医保区划
          "psn_no":	store.state.ybStore.m1101Output.output.baseinfo.psn_no , //人员编号 
          "omsgid": v_omsgid, //	原发送方报文ID
          "oinfno":	v_oinfno, //	原交易编号
        }


        await this.request_yb('yb2005', input).then(res => {
          if (res.infcode == "0") {
              console.log(res)

              store.dispatch('changeM2207Output', {});
              store.dispatch('changeM2204Output', {});
              store.dispatch('changeM2201Output', {});
              store.dispatch('changeYb2001Input', {});
              store.dispatch('changeYb2001Output', {});
              store.dispatch('changeYbjsflag', "");
              result = "1"
          } else {
              ElementUI.Message({
                  message: "撤销医保结算失败"+res.err_msg,
                  type: 'error',
                  offset:300
              })

              result = "-1"
          }
        })

        return  result
      },

      async yb2004(){
        let result = "-1"
        
        let input = {
          "insuplc_admdvs":store.state.ybStore.insuplc_admdvs,	//参保地医保区划
          "psn_no":	store.state.ybStore.m1101Output.output.baseinfo.psn_no , //人员编号 
          "mdtrt_id": store.state.ybStore.m2201Output.output.data.mdtrt_id, //	就诊 ID 
          "ipt_otp_no":	store.state.ybStore.m2201Output.output.data.ipt_otp_no, //	住院/门诊号 
          "setl_id":	store.state.ybStore.m2207Output.output.setlinfo.setl_id //结算 ID 
        }


        await this.request_yb('yb2004', input).then(res => {
          if (res.infcode == "0") {
              console.log(res)

              store.dispatch('changeM2207Output', {});
              store.dispatch('changeM2204Output', {});
              store.dispatch('changeM2201Output', {});
              store.dispatch('changeYb2001Input', {});
              store.dispatch('changeYb2001Output', {});
              store.dispatch('changeYbjsflag', "");
              result = "1"
          } else {
              ElementUI.Message({
                  message: "撤销医保结算失败"+res.err_msg,
                  type: 'error',
                  offset:300
              })

              result = "-1"
          }
        })

        return  result
      },

      request_yb(code,input){
        console.log(input);
        
        return axios({
            method:'post',
            url: "http://10.200.5.56:8081/paymentplatform/insuranceService",
            // url: "/yb",
            data: {
              "qqflag":"",
              "infcode":code,
              "input":input
            }
        }).then(res => {
            console.log(res)
            return res.data;     
        }).catch(err => {
            console.error(err); 
            return err.data        
        });
        
      }

}